/**
 * Logikk for Organizational Digital Twin
 * Håndterer hierarkisk datastruktur og risiko-beregning.
 */

export const RISK_LEVELS = {
  HEALTHY: { label: 'Healthy', color: 'emerald', code: '#10b981', min: 76 },
  MODERATE: { label: 'Moderate Risk', color: 'amber', code: '#fbbf24', min: 51 },
  HIGH: { label: 'High Risk', color: 'orange', code: '#f97316', min: 26 },
  CRITICAL: { label: 'Critical Risk', color: 'rose', code: '#f43f5e', min: 0 }
};

export const getRiskProfile = (score) => {
  if (score >= RISK_LEVELS.HEALTHY.min) return RISK_LEVELS.HEALTHY;
  if (score >= RISK_LEVELS.MODERATE.min) return RISK_LEVELS.MODERATE;
  if (score >= RISK_LEVELS.HIGH.min) return RISK_LEVELS.HIGH;
  return RISK_LEVELS.CRITICAL;
};

export const orgStructure = {
  id: 'org-1',
  name: 'HMS-innsikt Global',
  type: 'Company',
  manager: 'Erik Jensen (CEO)',
  metrics: { we: 68, stress: 45, safety: 72, conflict: 20 },
  children: [
    {
      id: 'dept-1',
      name: 'Utvikling',
      type: 'Department',
      manager: 'Sarah Chen (CTO)',
      metrics: { we: 42, stress: 82, safety: 35, conflict: 24 },
      children: [
        {
          id: 'team-1',
          name: 'Frontend Team',
          type: 'Team',
          manager: 'Lars Nordmann',
          metrics: { we: 35, stress: 88, safety: 30, conflict: 35 },
          employees: 12
        },
        {
          id: 'team-2',
          name: 'Backend Team',
          type: 'Team',
          manager: 'Ingrid Berg',
          metrics: { we: 48, stress: 78, safety: 42, conflict: 15 },
          employees: 15
        }
      ]
    },
    {
      id: 'dept-2',
      name: 'Salg & Marked',
      type: 'Department',
      manager: 'Morten Kraft (CMO)',
      metrics: { we: 58, stress: 60, safety: 45, conflict: 72 },
      children: [
        {
          id: 'team-3',
          name: 'Salg Norge',
          type: 'Team',
          manager: 'Kari Trå',
          metrics: { we: 45, stress: 65, safety: 40, conflict: 85 },
          employees: 8
        },
        {
          id: 'team-4',
          name: 'Marked Global',
          type: 'Team',
          manager: 'John Doe',
          metrics: { we: 72, stress: 55, safety: 55, conflict: 50 },
          employees: 6
        }
      ]
    },
    {
      id: 'dept-3',
      name: 'Operasjon',
      type: 'Department',
      manager: 'Linda Vang (COO)',
      metrics: { we: 85, stress: 35, safety: 88, conflict: 15 },
      children: [
        {
          id: 'team-5',
          name: 'Support',
          type: 'Team',
          manager: 'Svein Olsen',
          metrics: { we: 80, stress: 45, safety: 85, conflict: 20 },
          employees: 25
        }
      ]
    }
  ]
};

export const identifyGaps = (node) => {
  const gaps = [];
  if (node.metrics.safety < 40) gaps.push("Kritisk lav psykologisk trygghet detektert.");
  if (node.metrics.stress > 75) gaps.push("Høy risiko for utbrenthet i lederleddet.");
  if (node.metrics.conflict > 60) gaps.push("Systemisk konflikt påvirker operativ leveranse.");
  return gaps;
};